/**
 * GET-CONTEXT-SIDE.UTILS
 * Side where a menu opens from a cell : on the right of the cell by default, on its left when the visible area
 * ends before the menu does (a cell far on the right of a wide matrix)
 */

interface Edges {
  left: number
  right: number
}

//The menu is aligned on the right edge of the cell (opens toward the left) only when it does not fit on the right and fits on the left
export function shouldAlignRight(cell: Edges, visible: Edges, menuWidth: number): boolean {
  const overflowsRight = cell.left + menuWidth > visible.right
  const fitsOnLeft = cell.right - menuWidth >= visible.left
  return overflowsRight && fitsOnLeft
}

//Visible horizontal area of an element : narrowed by every parent that clips or scrolls its content, and by the window
export function getVisibleArea(element: HTMLElement): Edges {
  let left = 0
  let right = window.innerWidth
  let parent = element.parentElement

  while (parent && parent !== document.body) {
    if (getComputedStyle(parent).overflowX !== "visible") {
      const rect = parent.getBoundingClientRect()
      left = Math.max(left, rect.left)
      right = Math.min(right, rect.right)
    }
    parent = parent.parentElement
  }

  return { left, right }
}
